export const isWithinOpeningHours = (): boolean => {
  const hour = new Date().getHours()
  const minutes = new Date().getMinutes()
  const day = new Date().getDay()

  const isMondayToThursday = day >= 1 && day < 5
  const isFriday = day === 5
  const isWeekend = day < 1 || day > 5

  if (isWeekend) return false

  if (isMondayToThursday) {
    return hour >= 16 || hour < 8 ? false : true
  }
  if (isFriday) {
    return (hour >= 15 && minutes >= 30) || hour < 8 ? false : true
  }
  return false
}
